import { FeatureToggle } from 'app/modules/feature-flags/FeatureToggle';
import { SentryRoute } from "../SentryRoute";
import { RequireAuth, useMeDetailsQuery, UserRole } from 'legoland-sdk/dist/experimental';
import { NavLink, Switch } from 'react-router-dom';
import { NavbarMenu, NavbarMenuItem, NavbarMenuLink } from 'tombac';
import { track } from "./track";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AppNavbarMenu = _ref => {
  let {
    breakpoint
  } = _ref;
  const meDetailsQuery = useMeDetailsQuery();
  if (!meDetailsQuery.isSuccess) return null;
  const {
    meDetails
  } = meDetailsQuery.data;
  const trackNavClick = label => {
    track('page_click', {
      specificProps: {
        component_name: 'header',
        component_sub_name: label
      }
    });
  };
  return meDetails ? /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(SentryRoute, {
      exact: true,
      path: "/"
    }), /*#__PURE__*/_jsx(SentryRoute, {
      exact: true,
      path: "/login"
    }), /*#__PURE__*/_jsx(SentryRoute, {
      children: /*#__PURE__*/_jsxs(NavbarMenu, {
        breakpoint: breakpoint,
        children: [/*#__PURE__*/_jsx(NavbarMenuItem, {
          "data-test": "navbar-dashboard",
          children: /*#__PURE__*/_jsx(NavbarMenuLink, {
            as: NavLink,
            onClick: () => trackNavClick('dashboard'),
            to: "/dashboard",
            children: "Dashboard"
          })
        }), !meDetails.isFallback && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(RequireAuth, {
            role: [UserRole.Admin, UserRole.Distributor, UserRole.Support],
            children: /*#__PURE__*/_jsx(NavbarMenuItem, {
              "data-test": "navbar-users",
              children: /*#__PURE__*/_jsx(NavbarMenuLink, {
                as: NavLink,
                onClick: () => trackNavClick('users'),
                to: "/users",
                children: "Users"
              })
            })
          }), /*#__PURE__*/_jsx(FeatureToggle, {
            off: true,
            name: "contracts",
            children: /*#__PURE__*/_jsx(RequireAuth, {
              role: [UserRole.Admin, UserRole.Distributor, UserRole.Support],
              children: /*#__PURE__*/_jsx(NavbarMenuItem, {
                children: /*#__PURE__*/_jsx(NavbarMenuLink, {
                  as: NavLink,
                  to: "/contracts",
                  onClick: () => trackNavClick('contracts'),
                  children: "Contracts"
                })
              })
            })
          }), /*#__PURE__*/_jsx(RequireAuth, {
            role: [UserRole.Admin, UserRole.Distributor, UserRole.Support],
            children: /*#__PURE__*/_jsx(NavbarMenuItem, {
              "data-test": "navbar-organizations",
              children: /*#__PURE__*/_jsx(NavbarMenuLink, {
                as: NavLink,
                onClick: () => trackNavClick('organizations'),
                to: "/organizations",
                children: "Organizations"
              })
            })
          }), /*#__PURE__*/_jsx(NavbarMenuItem, {
            "data-test": "navbar-reports",
            children: /*#__PURE__*/_jsx(NavbarMenuLink, {
              as: NavLink,
              onClick: () => trackNavClick('reports'),
              to: "/reports",
              children: "Reports"
            })
          }), /*#__PURE__*/_jsx(RequireAuth, {
            role: [UserRole.Admin, UserRole.Support],
            children: /*#__PURE__*/_jsx(NavbarMenuItem, {
              children: /*#__PURE__*/_jsx(NavbarMenuLink, {
                as: NavLink,
                onClick: () => trackNavClick('history'),
                to: "/history",
                children: "History"
              })
            })
          })]
        })]
      })
    })]
  }) : null;
};